import { defineStore } from 'pinia';

interface AppStateState {
  drawer: boolean;
}

export const useAppStateStore = defineStore('appState', {
  state: (): AppStateState => ({
    drawer: true,
  }),

  actions: {
    setDrawer(drawerStatus: boolean) {
      this.drawer = drawerStatus;
    },

    toggleDrawer() {
      this.drawer = !this.drawer;
    },
  },
});
